import React, { useState } from 'react';
import {
	makeStyles,
	Button,
	Box,
	withStyles,
	FormControlLabel,
	Checkbox,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import { TextField } from 'formik-material-ui';
import { Field, Form, Formik } from 'formik';
import TitleText from '../components/reusableComponents/TitleText';
import BodyText from '../components/reusableComponents/BodyText';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import BaggageForm from '../components/reusableComponents/BaggageForm';
import { toggleGSTModal, setPayment } from '../reducers/UiReducer';
import {
	FlightFareQuoteDispatch,
	FlightFareQuoteEtravDispatch,
	FlightFareRuleEtravDispatch,
	FlightSSREtravDispatch,
} from '../reducers/HomeReducer';
import { useSelector } from 'react-redux';
import ErrorModal from '../components/reusableComponents/ErrorModal';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 15,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 12,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
}));
const RedCheckbox = withStyles({
	root: {
		color: 'rgb(239, 51, 57)',
		'&$checked': {
			color: 'rgb(239, 51, 57)',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const country = ['Jharkhand', 'Kolkata'];
const visa = [
	'Tourist',
	'Employment',
	'Seamen',
	'Residence',
	'Student',
	'Dependent',
	'Migrant',
];
const title = ['Mr', 'Mrs'];
const FlightSummaryForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	// const [tabvalue, setValue] = React.useState(0);
	const [otp, setOtp] = React.useState(0);
	const location = useLocation();
	const [value, setValue] = React.useState(new Date());
	const [value2, setValue2] = React.useState(new Date());
	const [value3, setValue3] = React.useState(new Date());
	const [pass, setPass] = useState(false);
	const [checked, setChecked] = useState(false);
	const [hold, setHold] = useState(false);
	const [pay, setPay] = useState(false);
	const [check, setCheck] = useState(false);
	const [val, setVal] = React.useState(false);
	const [b, setB] = React.useState(false);
	const handleHold = (e) => {
		if (e.target.value === 'hold') {
			dispatch(setPayment(e.target.value));
			if (hold) {
				setHold(false);

				setPay(true);
			} else {
				setHold(true);
				setPay(false);
			}
		} else {
			dispatch(setPayment(e.target.value));
			if (pay) {
				setPay(false);
				setHold(true);
			} else {
				setPay(true);
				setHold(false);
			}
		}
		console.log(e.target.value);
	};

	const handleCheck = (event) => {
		setCheck(event.target.checked);
	};
	const { selectedOrigin, selectedDepart } = useSelector((state) => state.ui);
	console.log(
		selectedOrigin &&
			selectedOrigin.country_name === 'India' &&
			selectedDepart &&
			selectedDepart.country_name === 'India'
			? 'India'
			: 'Forein'
	);
	const handleFormSubmit = (data, actions) => {
		console.log(data);
		// if (location.state.OneflightData) {
		// 	if (location.state.OneflightData.Airline_Code) {
		// 		let formEtravFare = {
		// 			Search_Key: location.state.IDEtrav,
		// 			AirRepriceRequests: [
		// 				{
		// 					Flight_Key: location.state.OneflightData.Flight_Key,
		// 					Fare_Id: location.state.OneflightData.Fares[0].Fare_Id,
		// 				},
		// 			],
		// 			Customer_Mobile: '7870075616',
		// 			GST_Input: false,
		// 			SinglePricing: true,
		// 		};
		// 		let formEtravRule = {
		// 			Search_Key: location.state.IDEtrav,
		// 			Flight_Key: location.state.OneflightData.Flight_Key,
		// 			Fare_Id: location.state.OneflightData.Fares[0].Fare_Id,
		// 		};
		// 		let formSSR = {
		// 			Search_Key: location.state.IDEtrav,
		// 			AirSSRRequestDetails: [
		// 				{
		// 					// Flight_Key: location.state.OneflightData.Flight_Key,
		// 				},
		// 			],
		// 		};
		// 		dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
		// 		// dispatch(FlightFareRuleEtravDispatch(formEtravRule));
		// 	} else if (location.state.OneflightData.AirlineCode) {
		// 		let formData1 = {
		// 			TraceId: location.state.IDTBO,
		// 			ResultIndex: location.state.OneflightData.ResultIndex,
		// 		};
		// 		dispatch(FlightFareQuoteDispatch(formData1));
		// 	}
		// } else if (location.state.selectedonward) {
		// 	if (location.state.selectedonward[0].Airline_Code) {
		// 		let formEtravFare = {
		// 			Search_Key: location.state.IDEtrav,
		// 			AirRepriceRequests: [
		// 				{
		// 					Flight_Key: location.state.selectedonward[0].Flight_Key,
		// 					Fare_Id: location.state.selectedonward[0].Fares[0].Fare_Id,
		// 				},
		// 			],
		// 			Customer_Mobile: '7870075616',
		// 			GST_Input: false,
		// 			SinglePricing: true,
		// 		};
		// 		let formEtravRule = {
		// 			Search_Key: location.state.IDEtrav,
		// 			Flight_Key: location.state.selectedonward[0].Flight_Key,
		// 			Fare_Id: location.state.selectedonward[0].Fares[0].Fare_Id,
		// 		};
		// 		dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
		// 		// dispatch(FlightFareRuleEtravDispatch(formEtravRule));
		// 	} else if (location.state.selectedonward[0].AirlineCode) {
		// 		let formData1 = {
		// 			TraceId: location.state.IDTBO,
		// 			ResultIndex: location.state.selectedonward[0].ResultIndex,
		// 		};
		// 		dispatch(FlightFareQuoteDispatch(formData1));
		// 	}
		// } else if (location.state.selectedReturn) {
		// 	if (location.state.selectedReturn[0].Airline_Code) {
		// 		let formEtravFare = {
		// 			Search_Key: location.state.IDEtrav,
		// 			AirRepriceRequests: [
		// 				{
		// 					Flight_Key: location.state.selectedReturn[0].Flight_Key,
		// 					Fare_Id: location.state.selectedReturn[0].Fares[0].Fare_Id,
		// 				},
		// 			],
		// 			Customer_Mobile: '7870075616',
		// 			GST_Input: false,
		// 			SinglePricing: true,
		// 		};
		// 		let formEtravRule = {
		// 			Search_Key: location.state.IDEtrav,
		// 			Flight_Key: location.state.selectedReturn[0].Flight_Key,
		// 			Fare_Id: location.state.selectedReturn[0].Fares[0].Fare_Id,
		// 		};
		// 		dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
		// 		// dispatch(FlightFareRuleEtravDispatch(formEtravRule));
		// 	} else if (location.state.selectedReturn[0].AirlineCode) {
		// 		let formData1 = {
		// 			TraceId: location.state.IDTBO,
		// 			ResultIndex: location.state.selectedReturn[0].ResultIndex,
		// 		};
		// 		dispatch(FlightFareQuoteDispatch(formData1));
		// 	}
		// }

		// let formData = {
		// 	data: data,
		// 	value: value,
		// 	value2: value2,
		// 	value3: value3,
		// };
		// console.log(formData);
		// if (location.state.returnBody) {
		// 	history.push({
		// 		pathname: '/confirmflight',
		// 		state: {
		// 			formData: formData,
		// 			returnBody: location.state.returnBody,
		// 			Returnflight: location.state.Returnflight,
		// 			flightData: location.state.flightData,
		// 			ID: location.state.ID,
		// 			IDEtrav: location.state.IDEtrav,
		// 			IDTBO: location.state.IDTBO,
		// 			selectedReturn: location.state.selectedReturn,
		// 			selectedonward: location.state.selectedonward,
		// 		},
		// 	});
		// } else {
		// 	history.push({
		// 		pathname: '/confirmflight',
		// 		state: {
		// 			formData: formData,
		// 			body: location.state.body,
		// 			OneflightData: location.state.OneflightData,
		// 			IDTBO: location.state.IDTBO,
		// 			IDEtrav: location.state.IDEtrav,
		// 		},
		// 	});
		// }
	};
	function range(start, end) {
		return Array(end)
			.fill()
			.map((_, idx) => start + idx);
	}
	let ad = range(
		0,
		location.state.body
			? location.state.body.AdultCount
			: location.state.returnBody
			? location.state.returnBody.AdultCount
			: ''
	);
	let chld = range(
		0,
		location.state.body
			? location.state.body.ChildCount
			: location.state.returnBody
			? location.state.returnBody.ChildCount
			: ''
	);
	let inft = range(
		0,
		location.state.body
			? location.state.body.InfantCount
			: location.state.returnBody
			? location.state.returnBody.InfantCount
			: ''
	);
	// console.log(ad);
	// useEffect(() => {
	// 	const rememberMe = localStorage.getItem('isRemember');
	// 	if (rememberMe) {
	// 		setChecked(true);
	// 	}
	// }, []);

	return (
		<>
			<Formik
				initialValues={{
					email: location.state.formData
						? location.state.formData.data.email
						: '',
					phone: location.state.formData
						? location.state.formData.data.phone
						: '',
					first_name: location.state.formData
						? location.state.formData.data.first_name
						: '',
					state: location.state.formData
						? location.state.formData.data.state
						: '',
					title: location.state.formData
						? location.state.formData.data.title
						: '',
					last_name: location.state.formData
						? location.state.formData.data.last_name
						: '',
					passport: location.state.formData
						? location.state.formData.data.passport
						: '',
					visatype: location.state.formData
						? location.state.formData.data.visatype
						: '',
					address: location.state.formData
						? location.state.formData.data.address
						: '',
				}}
				validate={(values) => {
					const errors = {};
					// if (!values.email) {
					// 	errors.email = 'Required';
					// } else if (
					// 	!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
					// ) {
					// 	errors.email = 'Invalid email address';
					// }

					// if (!values.phone) {
					// 	errors.phone = 'Required';
					// }
					if (!values.first_name0) {
						errors.first_name0 = 'Required';
					}
					if (!values.last_name0) {
						errors.last_name0 = 'Required';
					}
					// if (!values.passport) {
					// 	errors.passport = 'Required';
					// }

					return errors;
				}}
				onSubmit={handleFormSubmit}>
				{({ submitForm, isSubmitting, values, errors }) => (
					<>
						{' '}
						<Form>
							<Box
								className={classes.root}
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Box display='flex' alignItems='center'>
									<TitleText
										four
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										Contact Details
									</TitleText>
									<BodyText
										four
										textStyle={{
											marginLeft: 20,
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										Your booking details will be sent to this email ID & mobile
										number.
									</BodyText>
								</Box>
								<Grid
									container
									spacing={2}
									alignItems='center'
									style={{ marginTop: 20, alignItems: 'baseline' }}>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='email'
											type='email'
											variant='outlined'
											label='Email ID'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='phone'
											type='number'
											variant='outlined'
											error={errors.phone}
											label='Mobile No.'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
									{/* <Grid item xs={12} lg={3}>
									<Field
										component={TextField}
										name='otp'
										type='number'
										variant='outlined'
										// error={errors.otp}
										label='Enter OTP.'
										// style={{ marginTop: 20 }}
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
											// startAdornment: (
											// 	<InputAdornment position='start'>
											// 		<PhoneIcon />
											// 	</InputAdornment>
											// ),
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
								</Grid> */}
									{/* <Grid item xs={3}>
									<Field
										component={TextField}
										select
										name='state'
										type='text'
										variant='outlined'
										error={errors.state}
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											className: classes.inputPropsStyle,
										}}>
										{country.map((item, index) => (
											<MenuItem key={index} value={item}>
												{item}
											</MenuItem>
										))}
									</Field>
								</Grid> */}
								</Grid>
							</Box>
							<Box
								className={classes.root}
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								{/* <Box display='flex' alignItems='center'>
								<TitleText
									textStyle={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									Contact Details
								</TitleText>
								<BodyText
									textStyle={{
										marginLeft: 20,
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									Your booking details will be sent to this email ID & mobile
									number.
								</BodyText>
							</Box> */}
								{ad.length > 0 &&
									ad.map((i, index) => {
										return (
											<>
												<Box display='flex'>
													<TitleText three textStyle={{ marginTop: 10 }}>
														{index + 1}
													</TitleText>
													<TitleText
														three
														textStyle={{ marginLeft: 5, marginTop: 10 }}>
														Adult
													</TitleText>
												</Box>
												<Grid
													container
													spacing={2}
													alignItems='center'
													style={{ marginTop: 20, alignItems: 'baseline' }}>
													<Grid
														item
														xs={12}
														sm={6}
														lg={4}
														className={classes.root2}
														style={{ alignItems: 'center' }}>
														<Field
															component={TextField}
															select
															name={`title${index}`}
															type='text'
															variant='outlined'
															label='Select Title'
															error={errors.title}
															// style={{ marginLeft: 10 }}
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																className: classes.inputPropsStyle,
															}}>
															{title.map((item, index) => (
																<MenuItem key={index} value={item}>
																	{item}
																</MenuItem>
															))}
														</Field>
													</Grid>
													<Grid item xs={12} sm={6} lg={4}>
														<Field
															component={TextField}
															name={`first_name${index}`}
															type='text'
															variant='outlined'
															label='Enter First Name'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
													</Grid>
													<Grid item xs={12} sm={6} lg={4}>
														<Field
															component={TextField}
															name={`last_name${index}`}
															type='text'
															variant='outlined'
															label='Enter Last Name'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
													</Grid>
													{/* <Grid
													item
													xs={12}
													sm={6}
													lg={3}
													className={classes.dob}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															views={['year', 'month', 'day']}
															value={value}
															onChange={(newValue) => {
																setValue(newValue);
															}}
															renderInput={(params) => (
																<TextField2
																	{...params}
																	variant='outlined'
																	name='date'
																	error={errors.date}
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid> */}
												</Grid>
												{/* {selectedOrigin &&
											selectedOrigin.country_name === 'India' &&
											selectedDepart &&
											selectedDepart.country_name === 'India' ? (
												''
											) : (
												<> */}
												<Grid
													container
													spacing={2}
													alignItems='center'
													style={{ marginTop: 10, alignItems: 'baseline' }}>
													{/* <Grid item xs={2}></Grid> */}
													<Grid item xs={12} sm={6} lg={6}>
														{selectedOrigin &&
														selectedOrigin.country_name === 'India' &&
														selectedDepart &&
														selectedDepart.country_name === 'India' ? (
															''
														) : (
															<Field
																component={TextField}
																name='passport'
																type='text'
																variant='outlined'
																label='Enter Passport Number'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														)}
													</Grid>
													<Grid
														item
														xs={6}
														sm={3}
														lg={3}
														className={classes.passport}>
														{selectedOrigin &&
														selectedOrigin.country_name === 'India' &&
														selectedDepart &&
														selectedDepart.country_name === 'India' ? (
															''
														) : (
															<LocalizationProvider
																dateAdapter={AdapterDateFns}>
																<DatePicker
																	// disableFuture
																	label='Expiry Date'
																	openTo='year'
																	views={['year', 'month', 'day']}
																	value={value2}
																	onChange={(newValue) => {
																		setValue2(newValue);
																	}}
																	renderInput={(params) => (
																		<TextField2
																			{...params}
																			variant='outlined'
																			name='date'
																			error={errors.date}
																			className={classes.date}
																		/>
																	)}
																/>
															</LocalizationProvider>
														)}
													</Grid>
													<Grid
														item
														xs={6}
														sm={3}
														lg={3}
														className={classes.passport}>
														{selectedOrigin &&
														selectedOrigin.country_name === 'India' &&
														selectedDepart &&
														selectedDepart.country_name === 'India' ? (
															''
														) : (
															<LocalizationProvider
																dateAdapter={AdapterDateFns}>
																<DatePicker
																	// disableFuture
																	label='Date'
																	openTo='year'
																	views={['year', 'month', 'day']}
																	value={value3}
																	onChange={(newValue) => {
																		setValue3(newValue);
																	}}
																	renderInput={(params) => (
																		<TextField2
																			{...params}
																			variant='outlined'
																			name='date'
																			error={errors.date}
																			className={classes.date}
																		/>
																	)}
																/>
															</LocalizationProvider>
														)}
													</Grid>
												</Grid>
												<Grid container spacing={2} alignItems='center'>
													<Grid item xs={8}>
														{selectedOrigin &&
														selectedOrigin.country_name === 'India' &&
														selectedDepart &&
														selectedDepart.country_name === 'India' ? (
															''
														) : (
															<Field
																component={TextField}
																name='address'
																type='text'
																variant='outlined'
																label='Enter Issuing Place'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														)}
													</Grid>
													<Grid item xs={4}>
														{selectedOrigin &&
														selectedOrigin.country_name === 'India' &&
														selectedDepart &&
														selectedDepart.country_name === 'India' ? (
															''
														) : (
															<Field
																component={TextField}
																select
																name='visatype'
																type='text'
																variant='outlined'
																error={errors.visatype}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{visa.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														)}
													</Grid>
												</Grid>
											</>
											// 	)}
											// </>
										);
									})}
								{chld.length > 0 &&
									chld.map((i, index) => {
										return (
											<>
												<Box display='flex'>
													<TitleText two textStyle={{ marginTop: 10 }}>
														{index + 1}
													</TitleText>
													<TitleText
														two
														textStyle={{ marginLeft: 5, marginTop: 10 }}>
														Child
													</TitleText>
												</Box>
												<Grid
													container
													spacing={2}
													alignItems='center'
													style={{ marginTop: 20 }}>
													<Grid
														item
														xs={3}
														style={{ display: 'flex', alignItems: 'center' }}>
														<Field
															component={TextField}
															select
															name='title'
															type='text'
															variant='outlined'
															label='Select Title'
															error={errors.title}
															// style={{ marginLeft: 10 }}
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																className: classes.inputPropsStyle,
															}}>
															{title.map((item, index) => (
																<MenuItem key={index} value={item}>
																	{item}
																</MenuItem>
															))}
														</Field>
													</Grid>
													<Grid item xs={3}>
														<Field
															component={TextField}
															name='first_name'
															type='text'
															variant='outlined'
															label='Enter First Name'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
													</Grid>
													<Grid item xs={3}>
														<Field
															component={TextField}
															name='last_name'
															type='text'
															variant='outlined'
															label='Enter Last Name'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
													</Grid>
													<Grid item xs={3}>
														<LocalizationProvider dateAdapter={AdapterDateFns}>
															<DatePicker
																// disableFuture
																label='Date'
																openTo='year'
																views={['year', 'month', 'day']}
																value={value}
																onChange={(newValue) => {
																	setValue(newValue);
																}}
																renderInput={(params) => (
																	<TextField2
																		{...params}
																		variant='outlined'
																		name='date'
																		error={errors.date}
																		className={classes.date}
																	/>
																)}
															/>
														</LocalizationProvider>
													</Grid>
												</Grid>
												{selectedOrigin &&
												selectedOrigin.country_name === 'India' &&
												selectedDepart &&
												selectedDepart.country_name === 'India' ? (
													''
												) : (
													<>
														<Grid
															container
															spacing={2}
															alignItems='center'
															style={{ marginTop: 10, alignItems: 'baseline' }}>
															{/* <Grid item xs={2}></Grid> */}
															<Grid item xs={12} sm={6} lg={6}>
																<Field
																	component={TextField}
																	name='passport'
																	type='text'
																	variant='outlined'
																	label='Enter Passport Number'
																	className={classes.selectField}
																	InputProps={{
																		className: classes.InputPropsStyle,
																	}}
																	inputProps={{
																		style: { padding: 12 },
																	}}
																/>
															</Grid>
															<Grid
																item
																xs={6}
																sm={3}
																lg={3}
																className={classes.passport}>
																<LocalizationProvider
																	dateAdapter={AdapterDateFns}>
																	<DatePicker
																		// disableFuture
																		label='Expiry Date'
																		openTo='year'
																		views={['year', 'month', 'day']}
																		value={value2}
																		onChange={(newValue) => {
																			setValue2(newValue);
																		}}
																		renderInput={(params) => (
																			<TextField2
																				{...params}
																				variant='outlined'
																				name='date'
																				error={errors.date}
																				className={classes.date}
																			/>
																		)}
																	/>
																</LocalizationProvider>
															</Grid>
															<Grid
																item
																xs={6}
																sm={3}
																lg={3}
																className={classes.passport}>
																<LocalizationProvider
																	dateAdapter={AdapterDateFns}>
																	<DatePicker
																		// disableFuture
																		label='Date'
																		openTo='year'
																		views={['year', 'month', 'day']}
																		value={value3}
																		onChange={(newValue) => {
																			setValue3(newValue);
																		}}
																		renderInput={(params) => (
																			<TextField2
																				{...params}
																				variant='outlined'
																				name='date'
																				error={errors.date}
																				className={classes.date}
																			/>
																		)}
																	/>
																</LocalizationProvider>
															</Grid>
														</Grid>
														<Grid container spacing={2} alignItems='center'>
															<Grid item xs={8}>
																<Field
																	component={TextField}
																	name='address'
																	type='text'
																	variant='outlined'
																	label='Enter Issuing Place'
																	className={classes.selectField}
																	InputProps={{
																		className: classes.InputPropsStyle,
																	}}
																	inputProps={{
																		style: { padding: 12 },
																	}}
																/>
															</Grid>
															<Grid item xs={4}>
																<Field
																	component={TextField}
																	select
																	name='visatype'
																	type='text'
																	variant='outlined'
																	error={errors.visatype}
																	className={classes.selectField}
																	InputProps={{
																		className: classes.InputPropsStyle,
																	}}
																	inputProps={{
																		className: classes.inputPropsStyle,
																	}}>
																	{visa.map((item, index) => (
																		<MenuItem key={index} value={item}>
																			{item}
																		</MenuItem>
																	))}
																</Field>
															</Grid>
														</Grid>
													</>
												)}
											</>
										);
									})}
								{inft.length > 0 &&
									inft.map((i, index) => {
										return (
											<>
												<Box display='flex'>
													<TitleText two textStyle={{ marginTop: 10 }}>
														{index + 1}
													</TitleText>
													<TitleText
														two
														textStyle={{ marginLeft: 5, marginTop: 10 }}>
														Infant
													</TitleText>
												</Box>
												<Grid
													container
													spacing={2}
													alignItems='center'
													style={{ marginTop: 20 }}>
													<Grid
														item
														xs={3}
														style={{ display: 'flex', alignItems: 'center' }}>
														<Field
															component={TextField}
															select
															name='title'
															type='text'
															variant='outlined'
															label='Select Title'
															error={errors.title}
															// style={{ marginLeft: 10 }}
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																className: classes.inputPropsStyle,
															}}>
															{title.map((item, index) => (
																<MenuItem key={index} value={item}>
																	{item}
																</MenuItem>
															))}
														</Field>
													</Grid>
													<Grid item xs={3}>
														<Field
															component={TextField}
															name='first_name'
															type='text'
															variant='outlined'
															label='Enter First Name'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
													</Grid>
													<Grid item xs={3}>
														<Field
															component={TextField}
															name='last_name'
															type='text'
															variant='outlined'
															label='Enter Last Name'
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
													</Grid>
													<Grid item xs={3}>
														<LocalizationProvider dateAdapter={AdapterDateFns}>
															<DatePicker
																// disableFuture
																label='Date'
																openTo='year'
																views={['year', 'month', 'day']}
																value={value}
																onChange={(newValue) => {
																	setValue(newValue);
																}}
																renderInput={(params) => (
																	<TextField2
																		{...params}
																		variant='outlined'
																		name='date'
																		error={errors.date}
																		className={classes.date}
																	/>
																)}
															/>
														</LocalizationProvider>
													</Grid>
												</Grid>
												{selectedOrigin &&
												selectedOrigin.country_name === 'India' &&
												selectedDepart &&
												selectedDepart.country_name === 'India' ? (
													''
												) : (
													<>
														<Grid
															container
															spacing={2}
															alignItems='center'
															style={{ marginTop: 10, alignItems: 'baseline' }}>
															{/* <Grid item xs={2}></Grid> */}
															<Grid item xs={12} sm={6} lg={6}>
																<Field
																	component={TextField}
																	name='passport'
																	type='text'
																	variant='outlined'
																	label='Enter Passport Number'
																	className={classes.selectField}
																	InputProps={{
																		className: classes.InputPropsStyle,
																	}}
																	inputProps={{
																		style: { padding: 12 },
																	}}
																/>
															</Grid>
															<Grid
																item
																xs={6}
																sm={3}
																lg={3}
																className={classes.passport}>
																<LocalizationProvider
																	dateAdapter={AdapterDateFns}>
																	<DatePicker
																		// disableFuture
																		label='Expiry Date'
																		openTo='year'
																		views={['year', 'month', 'day']}
																		value={value2}
																		onChange={(newValue) => {
																			setValue2(newValue);
																		}}
																		renderInput={(params) => (
																			<TextField2
																				{...params}
																				variant='outlined'
																				name='date'
																				error={errors.date}
																				className={classes.date}
																			/>
																		)}
																	/>
																</LocalizationProvider>
															</Grid>
															<Grid
																item
																xs={6}
																sm={3}
																lg={3}
																className={classes.passport}>
																<LocalizationProvider
																	dateAdapter={AdapterDateFns}>
																	<DatePicker
																		// disableFuture
																		label='Date'
																		openTo='year'
																		views={['year', 'month', 'day']}
																		value={value3}
																		onChange={(newValue) => {
																			setValue3(newValue);
																		}}
																		renderInput={(params) => (
																			<TextField2
																				{...params}
																				variant='outlined'
																				name='date'
																				error={errors.date}
																				className={classes.date}
																			/>
																		)}
																	/>
																</LocalizationProvider>
															</Grid>
														</Grid>
														<Grid container spacing={2} alignItems='center'>
															<Grid item xs={8}>
																<Field
																	component={TextField}
																	name='address'
																	type='text'
																	variant='outlined'
																	label='Enter Issuing Place'
																	className={classes.selectField}
																	InputProps={{
																		className: classes.InputPropsStyle,
																	}}
																	inputProps={{
																		style: { padding: 12 },
																	}}
																/>
															</Grid>
															<Grid item xs={4}>
																<Field
																	component={TextField}
																	select
																	name='visatype'
																	type='text'
																	variant='outlined'
																	error={errors.visatype}
																	className={classes.selectField}
																	InputProps={{
																		className: classes.InputPropsStyle,
																	}}
																	inputProps={{
																		className: classes.inputPropsStyle,
																	}}>
																	{visa.map((item, index) => (
																		<MenuItem key={index} value={item}>
																			{item}
																		</MenuItem>
																	))}
																</Field>
															</Grid>
														</Grid>
													</>
												)}
											</>
										);
									})}
							</Box>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Box>
									<Grid container>
										<Grid item xs={6} sm={2} style={{ textALign: 'center' }}>
											<Box
												onClick={() => (b ? setB(false) : setB(true))}
												style={{
													padding: '8px 9px',
													// display: inline-flex;
													textalign: 'center',
													backgroundColor: 'rgb(239, 51, 57)',
													color: 'white',
													cursor: 'pointer',
													alignItems: 'center',

													// width: '10%',
												}}>
												<BodyText textStyle={{ fontSize: 14 }}>
													Baggage
												</BodyText>
											</Box>
										</Grid>
										<Grid item xs={6} sm={2}></Grid>
										<Grid item xs={6} sm={2}></Grid>
										<Grid item xs={6} sm={2}></Grid>
										<Grid item xs={6} sm={2}></Grid>
										<Grid item xs={6} sm={2}></Grid>
									</Grid>
									{b ? (
										<>
											<Box
												mt={'15px'}
												ml={'20px'}
												onMouseEnter={() => setVal(true)}
												onMouseLeave={() => setVal(false)}
												style={{
													display: 'block',
													padding: '6px',
													color: 'dark',
													backgroundColor: val ? '#39c9bb' : 'white',
													border: '1px solid rgb(239, 51, 57)',
													borderRadius: '4px',
													transition: 'all .3s',
													textAlign: 'center',
													width: '12%',
												}}>
												<BodyText>DEL-CCU</BodyText>
											</Box>
											<Box>
												<BaggageForm />
											</Box>
											<BodyText>Total Amount = ₹ 4000</BodyText>
											<BodyText two>
												Note: Pre-booked baggage is 15% cheaper than on-board
												price
											</BodyText>
										</>
									) : (
										''
									)}
								</Box>
							</Box>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Box
									display='flex'
									alignItems='center'
									onClick={() => {
										dispatch(toggleGSTModal(true));
									}}>
									<TitleText textStyle={{ color: '#007bff', fontSize: 16 }}>
										Add GST Details
									</TitleText>
								</Box>
								<Box>
									<BodyText three>
										NOTE: (1) GSTIN can’t be updated once booking is completed.
										(2) Your Taxes may get updated post submitting GST details.
									</BodyText>
								</Box>
							</Box>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<FormControlLabel
									control={
										<RedCheckbox
											checked={check}
											onChange={handleCheck}
											name='checkedG'
										/>
									}
									label='I Agree'
								/>
							</Box>
							{/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<FormControlLabel
									value='hold'
									control={<Radio checked={hold} onClick={handleHold} />}
									label='Hold'
								/>
								<FormControlLabel
									value='pay'
									control={<Radio checked={pay} onClick={handleHold} />}
									label='Pay Online'
								/>
							</Box> */}

							<Grid container spacing={4} alignItems='center'>
								<Grid item xs={3}></Grid>
								<Grid item xs={4}>
									<Button
										className={classes.createButton}
										onClick={submitForm}
										style={{ marginTop: 10, fontSize: 16 }}
										disabled={isSubmitting}>
										CONTINUE
									</Button>
								</Grid>
								<Grid item xs={4}></Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
			<ErrorModal />
		</>
	);
};

export default FlightSummaryForm;
